export enum Variants {
  FILTER = 'FILTER',
  LIST = 'LIST'
}
